import React, { useState, useEffect } from "react";
import axios from "axios";
import { Badge, Table, Input, DatePicker, Space, Card, Row, Col, message, Image, Avatar, Button, Carousel } from "antd";
import { Link, useParams, useNavigate } from "react-router-dom";
import moment from "moment";
import { ConsoleSqlOutlined, PlusOutlined, CloseCircleOutlined, EditOutlined } from "@ant-design/icons";
import TeacherModal from './components/TeacherModal';
const { RangePicker } = DatePicker;

const AdminTeacher = () => {
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [title, setTitle] = useState('新增老師');
    const [edit, setEdit] = useState(false);
    const [open, setOpen] = useState(false);
    const [open_wyswyg, set_open_wyswyg] = useState(false);
    const [color, setColor] = useState('d65b77');
    const [editcard, setEditCard] = useState({});
    const [content, setContent] = useState('');
    const [datas, setDatas] = useState([])
    const [messageApi, contextHolder] = message.useMessage();

    const handleOnEdit = (key) => {
        setTitle('修改老師');
        setColor('f09a45');
        setEdit(true);
        datas.map((value, index) => {
            if (value.blog_id == key) {
                setEditCard(value);
            }
        })
        setOpen(true)
    }
    const get_data = () => {
        axios
            .get('/cramSchool/api/blog/teacher', { params: { "blog_type_id": 4 } })
            .then((response) => {
                setDatas(response.data);
                get_picture(response.data);
            })
    }
    const get_picture = (data_tmp) => {
        // console.log(data_tmp);
        data_tmp && data_tmp.map((value, index) => {
            let blog_id = value['blog_id']
            if (value.file_id.length != 0) {
                value.file_id.map((tmp, key) => {
                    // console.log(key, tmp);
                    // tmp['file_id']
                    axios
                        .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": tmp } })
                        .then((response) => {
                            var blob_ = new Blob([response.data], {
                                type: "image/jpg",// this is the only MIME for SVG

                            });
                            const dataurl = URL.createObjectURL(blob_);
                            setDatas(
                                (pre) => {
                                    return (
                                        pre.map((value, index) => {
                                            if (blog_id == value.blog_id) {
                                                if (value.file_url != undefined) {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [...value.file_url, dataurl]
                                                        }
                                                    )
                                                } else {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [dataurl]
                                                        }
                                                    )
                                                }
                                            } else {
                                                return (
                                                    { ...value }
                                                )

                                            }
                                        })
                                    )
                                }
                            )

                        })
                })
            }
        })

    }
    const get_header = () => {
        axios
            .get('/cramSchool/api/blog/header/teacher', { params: { "blog_type_id": 6, "blog_id": 105 } })
            .then((response) => {
                setContent(response.data[0].content);
            })
    }
    useEffect(() => {
        get_data();
        get_header();
    }, [])
    const handleEdit = (file_id) => {
        setOpen(false);
        // let data_tmp = [{ ...editcard }];
        if (editcard['file_id'] == "{0}") {
            editcard['file_id'] = null;
        }
        // console.log(editcard); 
        axios
            .patch(`/cramSchool/api/blog/teacher`, [{ ...editcard, file_id, "blog_type_id": 4 }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '修改失敗',
                    });
                    get_data();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '修改成功',
                    });
                    get_data();
                }
            })
    }
    const handleSubmit = (file_id) => {
        if (JSON.stringify(editcard) == '{}') {
            // setOpen(false);
            messageApi.open({
                type: 'error',
                content: '新增失敗，請填寫任一欄位',
            });
        } else {
            if (editcard['annoucement_time'] == undefined) {
                var Today = new Date();
                editcard['annoucement_time'] = `${Today.getFullYear()}-${Today.getMonth() + 1}-${Today.getDate()}`;
            }
            axios
                .post(`/cramSchool/api/blog/teacher`, [{ ...editcard, file_id, "blog_type_id": 4 }])
                .then((response) => {
                    if (response.data.status == 'failure') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '新增失敗',
                        });
                        get_data();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '新增成功',
                        });
                        get_data();
                    }
                })
            // console.log(editcard);   
        }
    }
    const handleDelete = () => {
        const deleterow = [];
        selectedRowKeys && selectedRowKeys.map((value) => {
            deleterow.push({ 'blog_id': value });
        })
        axios
            .delete('/cramSchool/api/blog/teacher', {
                data: deleterow
            })
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '刪除失敗',
                    });
                    get_data();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '刪除成功',
                    });
                    get_data();
                }
            })

    }
    const handleDeleteRow = (id) => {
        const deleterow = [{ "blog_id": id }];
        axios
            .delete('/cramSchool/api/blog/teacher', {
                data: deleterow
            })
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '刪除失敗',
                    });
                    get_data();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '刪除成功',
                    });
                    get_data();
                }
            })

    }
    const rowSelection = {
        selectedRowKeys: selectedRowKeys,
        onSelectAll: (selected, selectedRows, changeRows) => {
            if (selectedRowKeys.length !== 0) {
                setSelectedRowKeys([]);
            }
        },
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRowKeys(selectedRowKeys);
        },
    };
    return (
        <>
            {contextHolder}
            <TeacherModal
                open={open}
                edit={edit}
                title={title}
                color={color}
                editcard={editcard}
                setEditCard={setEditCard}
                setOpen={setOpen}
                handleEdit={handleEdit}
                handleSubmit={handleSubmit}
                handleDelete={handleDelete}

            />
            <Row gutter={[8, 16]} style={{ paddingTop: '10px' }}>
                <Col span={24}>
                    <Row gutter={8}>
                        <Space wrap>
                            {/* <label style={{ fontSize: '24px', color: '#505050' }}>搜尋：</label> */}
                            <Input placeholder='請輸入老師名稱' />
                            <Button style={{ background: 'rgba(43, 193, 123, 1)', color: '#ffffff' }} block>搜尋</Button>
                            <Button className='example' style={{ backgroundColor: '#FdF9C9', display: "inline-flex", alignItems: "center" }} onClick={e => { setTitle('新增老師'); setColor('FF6B90'); setEditCard({}); setEdit(false); setOpen(true) }} icon={<PlusOutlined />}>新增老師</Button >
                            <Button style={{ backgroundColor: 'rgba(255, 242, 237, 1)' }} icon={<CloseCircleOutlined />} onClick={e => handleDelete()}>批次刪除</Button>
                        </Space>
                    </Row>
                </Col>
                <Col span={24}>
                    <Table
                        dataSource={datas}
                        columns={[
                            {
                                title: '照片',
                                key: 'blog_id',
                                render: (text, record, index) => (
                                    <Row gutter={8}>
                                        {/* <Carousel> */}
                                        {record['file_url'] ? record['file_url'].map((tmp, index) => {
                                            return (
                                                <>
                                                    <Col >
                                                        <img width="80px" height="100%" alt="example" src={tmp} style={{ width: '300', height: '300', borderRadius: '50%' }} />
                                                    </Col>
                                                </>
                                            )
                                        }) :
                                            <>
                                                <Col>
                                                    <img style={{ width: '300', height: '300', borderRadius: '50%' }} width="80px" height="100%" src="data:image/png;base64,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" />
                                                </Col>
                                            </>}
                                        {/* </Carousel> */}
                                        {/* <img src="https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png" width={'100 %'}></img> */}
                                    </Row >
                                )
                            },
                            {
                                title: '資訊',
                                key: 'blog_id',
                                render: (text, record, index) => (
                                    <>
                                        <Col >
                                            <p style={{ fontSize: '24px', fontWeight: 400, }}>{record.title}</p>
                                            <Badge count={'男性'} />
                                            <Badge count={'本國人士'} />
                                            {/* <p style={{ fontSize: '18px', fontWeight: 400, }}>{record.content}</p> */}
                                            <p style={{ fontSize: '16px', fontWeight: 400, color: '#00000040' }}>{record.last_edit_time}</p>
                                        </Col>
                                    </>
                                )
                            },
                            {
                                title: '操作',
                                key: 'control',
                                render: (text, record, index) => (
                                    <>
                                        <Button type="text" style={{ color: 'rgba(43, 193, 123, 1)' }} onClick={e => handleOnEdit(record.blog_id)}>編輯</Button>
                                        <Button type="text" style={{ color: 'red' }} onClick={(e) => handleDeleteRow(record.blog_id)}>刪除</Button>
                                    </>
                                )
                            },
                        ]}
                        scroll={{ x: 'max-content' }}
                        tableLayout='fixed'
                        rowSelection={{
                            type: 'checkbox',
                            ...rowSelection,
                        }}
                        rowKey={record => record['blog_id']}
                    />
                </Col>
            </Row>
        </>
    );
};

export default AdminTeacher;